import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames/bind'
import Button from '../../elementals/button'
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper'
import styles from '../../elementals/button/styles.scss'
const cx = classnames.bind(styles)

/**
 * ButtonGroupField
 *  This field requires an options array in the format of:
 *
 * {
 *    text: 'Button 1',
 *    value: 'A',
 *    active: false (optional)
 * }
 *
 * When using this field in redux-form, make sure to pass a handleButtonClick function at the field
 * level to change the prop value so validations and form logic work accordingly. The introduction
 * of the active property is intended to offer another option to maintaining the selected state.
 */
class ButtonGroupField extends Component {
  static propTypes = {
    fieldProps: PropTypes.object.isRequired,
    showError: PropTypes.bool,
  }

  state = {
    selected: this.props.fieldProps.singleMode
      ? 0
      : new Array(this.props.fieldProps.options.length),
  }

  onClick = (item, index) => () => {
    if (this.props.fieldProps.singleMode) {
      this.props.fieldProps.handleButtonClick(item?.value)
      this.setState({ selected: index })
    } else {
      this.props.fieldProps.handleButtonClick(item?.value)
      const newSelected = [...this.state.selected]
      newSelected[index] = newSelected[index] ? 0 : 1
      this.setState({ selected: newSelected })
    }
  }

  isSelected = index => {
    if (this.props.fieldProps.singleMode) {
      return this.state.selected === index
    } else {
      return this.state.selected[index] === 1
    }
  }

  render() {
    const { showError, fieldProps, ...rest } = this.props
    const { className, name, options, role, color, disabled } = fieldProps // eslint-disable-line

    let newColor = color
    if (showError) {
      newColor = 'error'
    } else if (newColor === 'adcLightGreen60') {
      newColor = 'adcLightGreen60'
    } else if (!role || role === 'default') {
      newColor = 'basic'
    } else {
      newColor = 'info'
    }

    return (
      <div className={cx(className)}>
        <Button.Group fluid>
          {options.map((item, index) => {
            return (
              <Button
                size='small'
                key={index}
                role='secondary'
                color={newColor}
                type='button'
                elmId={`${name}_button_group_${options[index].value}`}
                className={cx({ error: showError })}
                isSelected={
                  _.has(options[index], 'active')
                    ? options[index].active
                    : this.isSelected(index)
                }
                disabled={disabled}
                onClick={this.onClick(item, index)}
                {...rest}
              >
                {options[index].text}
              </Button>
            )
          })}
        </Button.Group>
      </div>
    )
  }
}

const ButtonGroupFieldWrapped = formFieldWrapper((fieldProps, showError) => (
  <ButtonGroupField fieldProps={fieldProps} showError={showError} />
))

ButtonGroupFieldWrapped.propTypes = {
  singleMode: PropTypes.bool,
  role: PropTypes.string,
  disabled: PropTypes.bool,
  wrap: PropTypes.bool,
  options: PropTypes.array.isRequired,
  ...commonPropTypes,
}

export default ButtonGroupFieldWrapped
